module.exports = __webpack_public_path__ + "static/media/cupones.81bd7c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/cupones.png
// module id = 1212
// module chunks = 0